export default function AreasController(
  $translate,
  $state,
  $scope,
  $rootScope,
  $stateParams,
  $window,
  merchantService,
  areasService,
  objectsService,
  NotificationService,
  FileUploader,
  OPTIONS,
  MERCHANT_PRODUCTS,
  FILES_TYPES,
) {
  var vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.isLoading = false;
  vm.areas = [];
  vm.area = {};
  vm.merchant = {};

  vm.uploadTypes = FILES_TYPES.AREA_FILES_TYPES;
  vm.uploadType = vm.uploadTypes[0];

  vm.bookingPriorities = OPTIONS.bookingPriorities;
  vm.addNewAreaEnabled = false;

  vm.init = init;
  vm.addArea = addArea;
  vm.loadArea = loadArea;
  vm.updateArea = updateArea;
  vm.deleteArea = deleteArea;
  vm.initNewArea = initNewArea;

  vm.uploader = new FileUploader();
  vm.backgroundUploader = new FileUploader();
  vm.fileToImport = {};

  vm.uploader.onAfterAddingFile = function(fileItem) {
    vm.fileToImport = fileItem._file;
  };

  vm.backgroundUploader.onAfterAddingFile = function(fileItem) {
    vm.backgroundToImport = fileItem._file;
  };

  vm.creationErrorMessage = null;

  var listener = $scope.$on('merchant.tab.areas.selected', vm.init);
  $scope.$on('merchant.configuration.updated', getAreas);
  $scope.$on('merchant.settings.updated', getAreas);

  function init() {
    listener();
    getObjectTypes();
    getAreas();
    initNewArea();
  }

  function getObjectTypes() {
    vm.isLoading = true;
    objectsService
      .getObjectTypes()
      .then(function(res) {
        $scope.objectTypes = res.data.objectTypes;
      })
      .catch(function() {
        NotificationService.error('Error getting table types');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function getAreas() {
    vm.isLoading = true;
    areasService
      .getAreas(vm.merchantId)
      .then(function(res) {
        vm.areas = res.data.areas;
        getMerchant();
      })
      .catch(function() {
        NotificationService.error('Error getting merchant areas');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function getMerchant() {
    vm.isLoading = true;
    merchantService
      .getMerchantById(vm.merchantId)
      .then(function(res) {
        vm.merchant = res.data;
        isAddNewAreaEnabled();
      })
      .catch(function() {
        NotificationService.error('Error getting merchant data');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function initNewArea() {
    vm.area = {
      onlineBookable: true,
    };
  }

  function isAddNewAreaEnabled() {
    vm.addNewAreaEnabled = !(vm.merchant.productIds.indexOf(MERCHANT_PRODUCTS.FREE_PLUS) > -1 && vm.areas.length >= 1);
  }

  function loadArea(areaId) {
    angular.forEach(vm.areas, function(value) {
      if (value.id === areaId) {
        vm.area = value;
        if (vm.area.backgroundImageUrl) {
          vm.area.backgroundName = vm.area.backgroundImageUrl.split('/').pop();
        }
        $scope.area = vm.area;
        $scope.$broadcast('merchant.tab.area-' + vm.area.id + '.loaded');
      }
    });
  }

  function addArea(addAreaForm) {
    if (vm.isLoading) {
      return;
    }
    vm.creationErrorMessage = null;
    vm.isLoading = true;
    areasService
      .addArea(vm.merchantId, vm.area, vm.fileToImport, vm.uploadType.value, vm.backgroundToImport)
      .then(function() {
        NotificationService.success('Merchant area created');
        getAreas();
        initNewArea();
        vm.uploader.clearQueue();
        angular.element("input[type='file']").val(null);
        addAreaForm.$setPristine();
        $rootScope.$broadcast('merchant.tab.areas.updated');
      })
      .catch(function(res) {
        var error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors,
          errorMessage = error.message ? $translate.instant(error.message) : 'Creating new merchant area failed';
        NotificationService.error('Area creation failed. Please see the table for information on the error');
        vm.creationErrorMessage = errorMessage;
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function updateArea() {
    if (vm.isLoading) {
      return;
    }
    vm.isLoading = true;
    delete vm.area.backgroundName;
    areasService
      .updateArea(vm.merchantId, vm.area.id, vm.area, vm.backgroundToImport)
      .then(function() {
        NotificationService.success('Merchant area successfully updated');
      })
      .catch(function(res) {
        var error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors,
          errorMessage = error.message ? $translate.instant(error.message) : 'Error updating merchant area';
        NotificationService.error(errorMessage);
      })
      .finally(function() {
        vm.isLoading = false;
        $state.reload();
      });
  }

  function deleteArea(areaId) {
    var confirmation;
    if (vm.isLoading) {
      return;
    }
    confirmation = $window.confirm('Are you sure you want to delete this area?');
    if (confirmation) {
      vm.isLoading = true;
      areasService
        .deleteArea(vm.merchantId, areaId)
        .then(function() {
          NotificationService.success('Merchant area deleted');
          getAreas();
          $rootScope.$broadcast('merchant.tab.areas.updated');
        })
        .catch(function(res) {
          var errorMessage = res.data.message ? res.data.message : 'Deleting merchant area failed';
          NotificationService.error(errorMessage);
        })
        .finally(function() {
          vm.isLoading = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/areas/areas.controller.js